:host {
  all: initial; // prevent inheritance
}

.plugin {
  background-color: #fcfcfd;
  color: #201f23;
  height: 100%;
  max-height: 100%;
  border-radius: 4px;
  position: relative;

  * {
    box-sizing: border-box;

    // generic global focus style
    &:focus {
      outline: auto;
      outline-offset: 2px;
    }
  }

  i {
    font-style: italic;
  }

  // make sure svgs display
  svg {
    min-height: 10px;
    min-width: 10px;
  }
}

.shadow {
  box-shadow: 0 7px 16px 0px #16161a29;
}

.title {
  font-size: 16px;
  padding: 10px;
  font-weight: 500;
  line-height: 1.2;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.section {
  overflow: hidden;
  max-height: 100%;
  display: flex;
  flex-direction: column;

  > * {
    flex: 0 0 auto; // nothing can grow except for the transcript
  }

  .transcript {
    flex: 1 1 auto;
  }
}

/* Utilities */

.flex {
  display: flex;
}

.aiCenter {
  align-items: center;
}

.jcEnd {
  justify-content: end;
}

.jcBetween {
  justify-content: space-between;
}

.displayNone {
  display: none;
}

.fullWidth {
  width: 100%;
}

.noOverflow {
  overflow: hidden;
}

.posRelative {
  position: relative;
}

// allow only span to be clicked so the even target is on the correct el
.noClick {
  pointer-events: none;
}

// screen reader only - visually hides element
.srOnly {
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  position: absolute;
  white-space: nowrap;
  width: 1px;
}

.skipLink {
  display: block;
  background: #e6006f;
  color: #fff;
  position: absolute;
  height: calc(100% - 8px);
  right: 0;
  top: 4px;
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 8px;
  font-size: 13px;
  border: none;
  transform: translateX(99.99%);
  // transition: transform 0.3s;
  transition: none; // removing animation until we have an animation that works with all browsers
  z-index: 11;

  @media (prefers-reduced-motion) {
    transition: none !important;
  }

  // cover up that 0.01% of untranslated button
  &::before {
    content: "";
    height: 100%;
    width: 4px;
    position: absolute;
    left: -2px;
    top: 0;
    background: black;
  }

  &:focus {
    transform: translateX(0);
    outline-color: black;
    right: 4px;

    &::before {
      display: none;
    }
  }
}

// On Chromium browsers, we can remove the border radius making the player
// look nicer. Safari has no way of modifying this in the same way sadly.
//
// We may want to eventually add our own player UI but that does lose native
// functionality.
audio::-webkit-media-controls-enclosure {
  border-radius: 0;
}

// For now, we add a bit of spacing to make safari look less broken.
// This supports query is a bit of a hack that may break in future.
// @see https://www.bram.us/2021/06/23/css-at-supports-rules-to-target-only-firefox-safari-chromium/#safari
// @see https://jsbin.com/yoqecol/edit?css,output
@supports (background: -webkit-named-image(i)) {
  :global(.space-hack) {
    padding: 4px 6px;
  }
}

.a {
  color: #e6006f;
}

.loadingContainer {
  display: flex;
  flex: 1 1 auto;
  justify-content: center;
  align-items: center;
  min-height: 300px;
  height: 100%;
  color: #656568;
}
